import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=bace0180&scoped=true"
import script from "./testPage.vue?vue&type=script&lang=js"
export * from "./testPage.vue?vue&type=script&lang=js"
import style0 from "./testPage.vue?vue&type=style&index=0&id=bace0180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace0180",
  null
  
)

export default component.exports